import { render, staticRenderFns } from "./Proccess.vue?vue&type=template&id=ded18bfa"
import script from "./Proccess.js?vue&type=script&lang=js&external"
export * from "./Proccess.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports